import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-load-management',
  templateUrl: './load-management.component.html',
  styleUrls: ['./load-management.component.scss']
})
export class LoadManagementComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
    const subscriptionType = localStorage.getItem("subscriptionType");
    if (subscriptionType === 'basic') {
      this.router.navigate(['load/createload']);
    } else {
      this.router.navigate(['load/ratecon-uploads']);
    }
  }

}
